export default {"src":"/_next/static/media/max.f6f7d4f7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};